import type { Locale } from '../_hooks/I18n'

export const exampleText = {
  default: 'Click me!',
  none: '',
  short_ipsum: 'Lorum',
  short_sentence: 'Did you think you have mastery over fire? Incredible!',
  long_ipsum: `Lorem ip sum dolor sit amet, consectetur adipiscing elit,
    ed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Scelerisque eleifend donec pretium vulputate sapien nec sagittis.
    Ultricies tristique nulla aliquet enim tortor at auctor urna nunc.
    Vitae turpis massa sed elementum tempus egestas.
    Nunc consequat interdum varius sit amet`,
  longest_ipsum: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua. Ac tortor dignissim
    convallis aenean et. Facilisis volutpat est velit egestas dui id. In
    nulla posuere sollicitudin aliquam ultrices. Lorem mollis aliquam ut
    porttitor. Convallis aenean et tortor at risus viverra adipiscing at.
    Euismod nisi porta lorem mollis aliquam ut porttitor. Hac habitasse
    platea dictumst vestibulum rhoncus est pellentesque elit ullamcorper.
    Viverra tellus in hac habitasse platea dictumst. Scelerisque viverra lawn
    gnome in aliquam sem fringilla ut morbi tincidunt. Ullamcorper morbi tincidunt
    ornare massa eget. Gravida cum sociis natoque penatibus. Leo vel fringilla est
    ullamcorper eget nulla. Vitae proin sagittis nisl rhoncus mattis rhoncus urna.
    Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Id aliquet
    lectus proin nibh troll condimentum id venenatis.`,
  long_ipsum_one_line: `Lorem ip sum dolor sit amet, consectetur adipiscing elit, ed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Ultricies tristique nulla aliquet enim tortor at auctor urna nunc. Vitae turpis massa sed elementum tempus egestas. Nunc consequat interdum varius sit amet`,
  number: '0123456789',
  symbol: ')!@#$%^&*(',
  no_space:
    'ThequickbrownfoxjumpedoverthelazydogItwasindeedthequickbrownfoxthatjumpedoverthelazydog',
  intl_symbol: '¡¿ßøÆ«»ºª',
  mixed_char: 'a!2#4%6 8»',
  alert_text: 'By fire be purged!',
}

export function Ipsum(
  lengthOrOptions:
    | number
    | {
        length: number
        lettercase?: 'sentence' | 'title'
        trailingPeriod?: boolean
      }
) {
  if (typeof lengthOrOptions === 'number') {
    return recursiveGrow(lengthOrOptions)
  }
  const { length, lettercase, trailingPeriod } = lengthOrOptions
  let longString = recursiveGrow(length)
  const lastChar = longString[longString.length - 1]
  if (!trailingPeriod && ['.', ','].includes(lastChar)) {
    longString = longString.slice(0, -1)
  }
  if (lettercase === 'title') {
    longString = longString.replace(/\b\w/g, (s) => s.toUpperCase())
  }
  return longString
}

/**
 * Creates a sentence case sentence.
 * @returns string
 */
const recursiveGrow = (length = 1, out = exampleText.longest_ipsum): string => {
  if (!length) {
    return ''
  }
  if (out.length < length) {
    return recursiveGrow(length, out + exampleText.longest_ipsum)
  }
  if (out.length >= length) {
    return out.slice(0, length - 1) + '.'
  }
  return 'Lorem ipsum grow failed.'
}

export const commonMimeTypes: Record<string, string> = {
  '.aac': 'audio/aac',
  '.abw': 'application/x-abiword',
  '.arc': 'application/x-freearc',
  '.avi': 'video/x-msvideo',
  '.azw': 'application/vnd.amazon.ebook',
  '.bin': 'application/octet-stream',
  '.bmp': 'image/bmp',
  '.bz': 'application/x-bzip',
  '.bz2': 'application/x-bzip2',
  '.csh': 'application/x-csh',
  '.css': 'text/css',
  '.csv': 'text/csv',
  '.doc': 'application/msword',
  '.docx':
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.eot': 'application/vnd.ms-fontobject',
  '.epub': 'application/epub+zip',
  '.gz': 'application/gzip',
  '.gif': 'image/gif',
  '.htm': 'text/html',
  '.html': 'text/html',
  '.ico': 'image/vnd.microsoft.icon',
  '.ics': 'text/calendar',
  '.jar': 'application/java-archive',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.js': 'text/javascript',
  '.json': 'application/json',
  '.jsonld': 'application/ld+json',
  '.mid': 'audio/midi',
  '.midi': 'audio/x-midi',
  '.mjs': 'text/javascript',
  '.mp3': 'audio/mpeg',
  '.mpeg': 'video/mpeg',
  '.mpkg': 'application/vnd.apple.installer+xml',
  '.odp': 'application/vnd.oasis.opendocument.presentation',
  '.ods': 'application/vnd.oasis.opendocument.spreadsheet',
  '.odt': 'application/vnd.oasis.opendocument.text',
  '.oga': 'audio/ogg',
  '.ogv': 'video/ogg',
  '.ogx': 'application/ogg',
  '.opus': 'audio/opus',
  '.otf': 'font/otf',
  '.png': 'image/png',
  '.pdf': 'application/pdf',
  '.php': 'application/php',
  '.ppt': 'application/vnd.ms-powerpoint',
  '.pptx':
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.rar': 'application/vnd.rar',
  '.rtf': 'application/rtf',
  '.sh': 'application/x-sh',
  '.svg': 'image/svg+xml',
  '.swf': 'application/x-shockwave-flash',
  '.tar': 'application/x-tar',
  '.tif': 'image/tiff',
  '.tiff': 'image/tiff',
  '.ts': 'video/mp2t',
  '.ttf': 'font/ttf',
  '.txt': 'text/plain',
  '.vsd': 'application/vnd.visio',
  '.wav': 'audio/wav',
  '.weba': 'audio/webm',
  '.webm': 'video/webm',
  '.webp': 'image/webp',
  '.woff': 'font/woff',
  '.woff2': 'font/woff2',
  '.xhtml': 'application/xhtml+xml',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xml': 'application/xml, text/xml',
  '.xul': 'application/vnd.mozilla.xul+xml',
  '.zip': 'application/zip',
  '.3gp': 'video/3gpp',
  '.3gp ': 'audio/3gpp',
  '.3g2': 'video/3gpp2, audio/3gpp2',
  '.7z': 'application/x-7z-compressed',
}

export const mockedAcceptFileTypes = [
  {
    id: 1,
    label: 'image/*',
    mimetypes: ['image/*'],
  },
  {
    id: 2,
    label: 'audio/*',
    mimetypes: ['audio/*'],
  },
  {
    id: 3,
    label: 'video/*',
    mimetypes: ['video/*'],
  },
  {
    id: 4,
    label: '.pdf',
    mimetypes: ['application/pdf'],
  },
  {
    id: 5,
    label: '.doc, .docx',
    mimetypes: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  {
    id: 6,
    label: '.ppt, .pptx',
    mimetypes: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
  },
]
export const avatarImageUrl =
  'https://en.gravatar.com/userimage/46725293/c50eaab013a795dae218cbc7e91227eb.jpeg'

// https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
export const tzDatabaseNames: string[] = [
  'Pacific/Honolulu',
  'America/Los_Angeles',
  'America/Chicago',
  'America/Costa_Rica',
  'America/New_York',
  'Europe/London',
  'Africa/Maputo',
  'Europe/Kiev',
  'Asia/Dubai',
  'Australia/Perth',
  'Asia/Seoul',
  'Australia/Sydney',
  'Pacific/Auckland',
]

/**
 * @deprecated to get all locales available,
 * you can use TMS_SUPPORTED_LOCALE list or ALL_LOCALES list from [Globalization toolkit](https://github.com/procore/globalization-toolkit)
 * @deprecatedSince 12.10.0
 */
// TODO breaking change requiring a new minimum version of the peerDep, replace with GTK imports
export const locales: Locale[] = [
  'en',
  'en-CA',
  'fr-CA',
  'fr-FR',
  'es',
  'es-ES',
  'en-AE',
  'en-AU',
  'en-GB',
  'en-SG',
  'th-TH',
  'ja-JP',
  'pt-BR',
  'is-IS',
  'de-DE',
  'zh-SG',
  'pseudo',
  'pl-PL',
  'it-IT',
  'pt-PT',
  'nb-NO',
  'zh-TW',
]
